import { Controller } from "stimulus";
import Sortable from "sortablejs";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: String,
    startIndex: { type: Number, default: 0 },
    sortingParam: { type: String, default: "position" },
    nested: Boolean,
  };

  connect() {
    this.nestedValue ? this.initializeNestedSortable() : this.initializeSortable(this.element);
  }

  disconnect() {
    this.destroySortable(this.sortable);
    this.sortables?.forEach(this.destroySortable);
  }

  initializeSortable(container) {
    this.sortable = this.createSortable(container);
  }

  initializeNestedSortable() {
    this.sortables = [];
    this.sortables.push(this.createSortable(this.element, false));

    this.element.querySelectorAll(".sortable-container").forEach((container) => {
      this.sortables.push(this.createSortable(container, false));
    });
  }

  createSortable(container, allowPut = false) {
    return Sortable.create(container, {
      group: { name: "nested", put: allowPut },
      animation: 150,
      filter: '.inactivated',
      handle: ".sorteable-handle",
      ghostClass: "blue-background-class",
      onEnd: this.onEnd.bind(this),
    });
  }

  destroySortable(sortable) {
    if (sortable) sortable.destroy();
  }

  onEnd(event) {
    const { newIndex, item, to } = event;

    const adjustedIndex = newIndex + this.startIndexValue;
    const paramName = this.sortingParamValue;
    const url = item.dataset.sortableUrl;

    const newParentId = this.getNewParentId(to);

    this.performReorderRequest(url, paramName, adjustedIndex, newParentId);
  }

  getNewParentId(container) {
    return container.closest(".sortable-item")
      ?.dataset.sortableUrl
      ?.match(/\d+$/)?.[0];
  }

  performReorderRequest(url, paramName, adjustedIndex, newParentId) {
    const data = { [paramName]: adjustedIndex };
    if (newParentId) data.parent_id = newParentId;

    patch(url, {
      body: JSON.stringify(data),
      headers: { Accept: "text/vnd.turbo-stream.html" }
    });
  }
}